import * as React from 'react';

export class ReportsLandingPageSvg extends React.Component<{}> {

  render() {
    return (
      <svg 
          width="507px" 
          height="225px" 
          viewBox="0 0 507 225" 
          version="1.1" 
          xmlns="http://www.w3.org/2000/svg" 
          xmlnsXlink="http://www.w3.org/1999/xlink"
          data-test-id="reports-landing-page-image"
      >

        <defs/>
        <g id="Reports" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Group-9" transform="translate(1.000000, 1.000000)" strokeWidth="2">
            <rect id="Rectangle-3" stroke="#CEE9F3" x="1" y="1" width="15" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="1" y="28" width="15" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="1" y="56" width="15" height="10"/>
            <rect id="Rectangle-3" stroke="#CEE9F3" x="1" y="84" width="15" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="1" y="111" width="15" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="1" y="139" width="15" height="10"/>
            <rect id="Rectangle-3" stroke="#CEE9F3" x="38" y="1" width="129" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="38" y="28" width="129" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="38" y="56" width="129" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="38" y="83" width="129" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="38" y="110" width="129" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="38" y="138" width="129" height="10"/>
            <rect id="Rectangle-3" stroke="#CEE9F3" x="188" y="1" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="188" y="28" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="188" y="56" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="188" y="83" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="188" y="110" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="188" y="138" width="96" height="10"/>
            <rect id="Rectangle-3" stroke="#CEE9F3" x="298" y="1" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="298" y="28" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="298" y="56" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="298" y="83" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="298" y="110" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="298" y="138" width="96" height="10"/>
            <rect id="Rectangle-3" stroke="#CEE9F3" x="408" y="1" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="408" y="28" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="408" y="56" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="408" y="83" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="408" y="110" width="96" height="10"/>
            <rect id="Rectangle-3-Copy" stroke="#CEE9F3" x="408" y="138" width="96" height="10"/>
            <g id="Group" transform="translate(343.000000, 82.000000)">
              <circle id="Oval" stroke="#C8ECF9" fill="#FFFFFF" cx="58" cy="58" r="58"/>
              <path d="M100.5,97.5 L142,138" id="Path-2" stroke="#D0EFFA"/>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}